(() => {
  if (window.AifufandLegacyMysteryGiftCleanupInitialized) return;
  window.AifufandLegacyMysteryGiftCleanupInitialized = true;

  const CART_SECTIONS = ["cart-drawer", "cart-icon-bubble"];
  const AUTO_GIFT_PROPERTY = "_auto_mystery_gift";

  function cartRoute(name, fallback) {
    return window.routes?.[name] || `${window.Shopify?.routes?.root || "/"}${fallback}`;
  }

  function isLegacyMysteryGift(item) {
    // `_is_free_gift` belongs to current bundle/SKU logic and must never be
    // treated as a legacy cleanup target.
    return item?.properties?.[AUTO_GIFT_PROPERTY] === "true";
  }

  async function readCart() {
    const response = await fetch(`${cartRoute("cart_url", "cart")}.js`, {
      headers: { Accept: "application/json" },
    });

    if (!response.ok) throw new Error(`Cart read failed: ${response.status}`);
    return response.json();
  }

  async function removeLegacyMysteryGift() {
    const cart = await readCart();
    if (!(cart.items || []).some(isLegacyMysteryGift)) return null;

    // This legacy cleanup must never race a foreground quantity/delete/add
    // request. Re-read after obtaining the shared slot so the update uses
    // current keys rather than the pre-wait cart snapshot.
    const coordinator = window.AifufandCartMutation;
    const mutation = coordinator?.reserve({ type: "legacy-mystery-gift-cleanup" });
    if (coordinator && !mutation) return null;

    let status;
    let retryAfter;
    try {
      if (mutation && !coordinator.start(mutation)) return null;
      const currentCart = mutation ? await readCart() : cart;
      const updates = Object.fromEntries(
        (currentCart.items || [])
          .filter(isLegacyMysteryGift)
          .map((item) => [item.key, 0]),
      );

      if (Object.keys(updates).length === 0) return null;

      const response = await fetch(`${cartRoute("cart_update_url", "cart/update")}.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          updates,
          sections: CART_SECTIONS,
          sections_url: window.location.pathname,
        }),
      });
      status = response.status;
      retryAfter = response.headers.get("Retry-After");

      if (!response.ok) throw new Error(`Mystery Gift removal failed: ${response.status}`);
      return response.json();
    } finally {
      if (mutation) coordinator.release(mutation, { status, retryAfter });
    }
  }

  async function cleanUpCart() {
    try {
      const result = await removeLegacyMysteryGift();
      const drawer = document.querySelector("cart-drawer");

      // Re-render only an already-open drawer. This keeps background page visits quiet.
      if (result && drawer?.classList.contains("active")) {
        document.dispatchEvent(new CustomEvent("cart:ajax-update", {
          detail: { sectionsData: result },
        }));
      }
    } catch (error) {
      console.error("Legacy Mystery Gift cleanup failed:", error);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", cleanUpCart, { once: true });
  } else {
    cleanUpCart();
  }

  window.AifufandMysteryGiftSync = {
    sync: cleanUpCart,
    schedule: () => {},
  };
})();
